module.exports = __webpack_public_path__ + "img/bg_12.b66ad77e.jpg";